// Chrome pins this extension's ID via the fixed "key" in manifest.json, so it's the
// same value for every install — never user- or environment-specific.
export const FINT_EXTENSION_ID = 'dnnidnmbjlpiillepinolklbeblbnccl';
